import { useGlobalAuthMergedStatus } from '@r-client/shared/data/auth';

import { useJurisdiction } from './use-jurisdiction';

export const useShowGlobalAuthRegionLinks = (): boolean => {
  const { isAuthenticated, accounts } = useJurisdiction();
  const { hasEuAccount, hasUkAccount } = accounts;
  const hasEuOrUk = hasEuAccount || hasUkAccount;

  const { data: mergedStatus } = useGlobalAuthMergedStatus({
    enabled: isAuthenticated && hasEuOrUk,
  });

  return (
    hasEuOrUk &&
    (mergedStatus?.usIsMerged === true ||
      mergedStatus?.usRegistrationEnabled === true)
  );
};
